import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, DropdownHeader, DropdownItem } from "flowbite-react";
import {
  HiChartPie,
  HiCog,
  HiPresentationChartLine,
  HiClipboardList,
  HiChevronDown,
  HiOutlineLightBulb,
  HiOutlineUser,
  HiOutlineLogout,
  HiOutlineX,
} from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import images from "../assets/images";
import { MdOutlineShoppingCart } from "react-icons/md";

export const SidebarComponent = ({
  isOpen,
  onToggleSidebar,
  setOpenModal,
  loginData,
}) => {
  const location = useLocation();
  const elemRef = useRef();
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const element = elemRef.current;
    if (!element) return;

    if (!isOpen) {
      setIsHovered(false);
      element.removeEventListener("mouseenter", handleMouseEnter);
      element.removeEventListener("mouseleave", handleMouseLeave);
    } else {
      const timeout = setTimeout(() => {
        element.addEventListener("mouseenter", handleMouseEnter);
        element.addEventListener("mouseleave", handleMouseLeave);
      }, 500);

      return () => {
        clearTimeout(timeout);
        element.removeEventListener("mouseenter", handleMouseEnter);
        element.removeEventListener("mouseleave", handleMouseLeave);
      };
    }

  }, [isOpen]);

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isHovered, setIsHovered] = useState(null);
  //const [forceCollapse, setForceCollapse] = useState(false);

  const handleDropClick = (menuName) => {
    setActiveDropdown((prev) => (prev === menuName ? null : menuName));
  };
  const handleToggle = () => {
    onToggleSidebar();
  };
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  console.log('Sidebar checking', window.innerWidth)
  return (
    <>
      <div
        className={`sticky top-0 peer w-auto collapseSide sidebar transition-all duration-300 h-screen z-10 
            ${
              isOpen && (!isHovered || window.innerWidth <= 1024) ? "collapseSide-closed" : "collapseSide-open"
            }
      `}
        ref={elemRef}
      >
        <div className="sidebar-logo mb-4">
          <div className="flex justify-between items-center w-full">
            <div className="flex gap-2">
              <img src={images.IrisLogo} alt="Iris" className="logoSec" />
              <span>Ultra Iris</span>
            </div>
            {window.innerWidth <= 1024 && <button type="button" className="sidebar-cross" onClick={handleToggle}><HiOutlineX /></button>}
            
          </div>
          <Button onClick={handleToggle} className="menuBtn mt-1">
            {isOpen ? (
              <img
                src={images.RightDoor}
                alt="icons"
                className="hover:opacity-70"
              />
            ) : (
              <img
                src={images.LeftDoor}
                alt="icons"
                className="hover:opacity-70"
              />
            )}
          </Button>
        </div>

        <div className="flex flex-col h-full justify-between menuSec">
          <div className="upperMenu">
            <ul className="menu">
              <li
                className={`menu-item has-dropdown 
                    ${activeDropdown === "accountAudit" ? "open" : ""}
                  `}
              >
                <div
                  className="menu-item-btn"
                  onClick={() => handleDropClick("accountAudit")}
                >
                  <i className="icon">
                    <HiChartPie />
                  </i>
                  <span className="text">Account Audit</span>
                  <HiChevronDown className="arrow" />
                </div>
                <ul className="submenu">
                  <li>
                    <Link className="link-name">Account Audit</Link>
                  </li>
                  <li>
                    <Link
                      className={`sidebar-a ${
                        isActive("/audit-report") ? "active" : ""
                      }`}
                      to="/audit-report"
                    >
                      Meta Ads
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`sidebar-a ${
                        isActive("/google-audit") ? "active" : ""
                      }`}
                      to="/google-audit"
                    >
                      Google Ads
                    </Link>
                  </li>
                </ul>
              </li>
              <li
                className={`menu-item ${
                  isActive("/media-planning") ? "active" : ""
                }`}
              >
                <Link className="menu-item-btn" to="/media-planning">
                  <i className="icon">
                    <HiClipboardList />
                  </i>
                  <span className="text">Planning</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/media-planning">
                      Planning
                    </Link>
                  </li>
                </ul>
              </li>
              {loginData?.role !== "User" && (
                <li
                  className={`menu-item has-dropdown 
                    ${activeDropdown === "optimization" ? "open" : ""}
                  `}
                >
                  <div
                    className="menu-item-btn"
                    onClick={() => handleDropClick("optimization")}
                  >
                    <i className="icon">
                      <HiCog />
                    </i>
                    <span className="text">Optimization AI</span>
                    <HiChevronDown className="arrow" />
                  </div>
                  <ul className="submenu">
                    <li>
                      <Link className="link-name">Optimization AI</Link>
                    </li>
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/optimization-status") ? "active" : ""
                        }`}
                        to="/optimization-status"
                      >
                        Status
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/active-take-off") ? "active" : ""
                        }`}
                        to="/active-take-off"
                      >
                        Take Off
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/optimization-co-pilot") ? "active" : ""
                        }`}
                        to="/optimization-co-pilot"
                      >
                        Co-Pilot
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              <li
                className={`menu-item ${
                  isActive("/creative-ai") ? "active" : ""
                }`}
              >
                <Link className="menu-item-btn" to="/creative-ai">
                  <i className="icon">
                    <HiOutlineLightBulb />
                  </i>
                  <span className="text">Creative AI</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/creative-ai">
                      Creative AI
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={`menu-item ${isActive("/audience") ? "active" : ""}`}
              >
                <Link className="menu-item-btn" to="/audience">
                  <i className="icon">
                    <HiOutlineUser />
                  </i>
                  <span className="text">Audience AI</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/audience">
                      Audience AI
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={`menu-item ${
                  isActive("/campaign-analytics") ? "active" : ""
                }`}
              >
                <Link className="menu-item-btn" to="/campaign-analytics">
                  <i className="icon">
                    <HiPresentationChartLine />
                  </i>
                  <span className="text">Campaign Analytics</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/campaign-analytics">
                      Campaign Analytics
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={`menu-item has-dropdown 
                    ${activeDropdown === "FeedManager" ? "open" : ""}
                  `}
              >
                <div
                  className="menu-item-btn"
                  onClick={() => handleDropClick("FeedManager")}
                >
                  <i className="icon">
                    <MdOutlineShoppingCart />
                  </i>
                  <span className="text">Feed Manager</span>
                  <HiChevronDown className="arrow" />
                </div>
                <ul className="submenu">
                  <li>
                    <Link className="link-name">Feed Manager</Link>
                  </li>
                  <li>
                    <Link
                      className={`sidebar-a ${
                        isActive("/feed-setting") ? "active" : ""
                      }`}
                      to="/feed-setting"
                    >
                      Feed Settings
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`sidebar-a ${
                        isActive("/catalogue-list") ? "active" : ""
                      }`}
                      to="/catalogue-list"
                    >
                      Catalogue List
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="bottomMenu">
            <div className="">
              <ul className="menu">
                {loginData?.role !== "User" && (
                  <li className="menu-item">
                    <Link className="menu-item-btn" to="/configure">
                      <i className="icon">
                        <HiCog />
                      </i>
                      <span className="text">Settings</span>
                    </Link>
                    <ul className="submenu blank">
                      <li>
                        <Link className="link-name" to="/configure">
                          Settings
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                {/* <li className="menu-item">
                      <Link className="menu-item-btn" to="/support">
                        <i className="icon"><HiDocumentText/></i>
                        <span className="text">Support</span>
                      </Link>
                      <ul className="submenu blank">
                        <li><Link className="link-name" to="/support">Support</Link></li>
                      </ul>
                    </li> */}
              </ul>

              <div className="pt-2 mt-2 border-t border-neutral-200 flex gap-3 items-center logOutSec">
                <Dropdown
                  renderTrigger={() => (
                    <button className="flex items-center gap-2 px-2">
                      <div className="flex items-center justify-center w-8 h-8 bg-blue-700 text-white text-base font-semibold rounded-full">
                        <span>
                          {loginData?.name
                            ?.split(" ")
                            .map((n) => n[0])
                            .join("")
                            .substring(0, 2)
                            .toUpperCase()}
                        </span>
                      </div>
                      <div className="avtarContent">
                        <div className="mb-0.5 text-sm font-semibold leading-none text-gray-900 dark:text-white peer-has-[collapseSide]:hidden">
                          {loginData?.name}
                        </div>
                        <div className="text-xs text-left text-gray-500 dark:text-gray-400">
                          {loginData?.role}
                        </div>
                      </div>
                    </button>
                  )}
                >
                  <DropdownHeader>
                    <div className="text-sm font-semibold leading-none text-gray-900 dark:text-white mb-1">
                      {loginData?.name}
                    </div>
                    <span className="text-xs text-left text-gray-500 dark:text-gray-400 block truncate">
                      {loginData?.email}
                    </span>
                  </DropdownHeader>
                  <DropdownItem>
                    <Link
                      className="flex items-center gap-3"
                      to="/change-password"
                    >
                      Change Password
                    </Link>
                  </DropdownItem>
                  <div class="my-1 h-px bg-gray-100 dark:bg-gray-600"></div>
                  <DropdownItem
                    className="text-red-600"
                    onClick={() => setOpenModal(true)}
                  >
                    <HiOutlineLogout className="mr-2 text-lg" /> Sign Out
                  </DropdownItem>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Sidebar
        theme={sidebarCustom}
        collapseBehavior="collapse"
        collapsed={isOpen}
        className={`sticky top-0 peer w-auto collapseSide transition-all duration-300 h-screen z-10 
          ${
          isOpen ? "collapseSide-closed" : "collapseSide-open" 
          }
        `}
        // onMouseEnter={() => setIsHovered(true)}
        // onMouseLeave={() => setIsHovered(false)}
      >
        <div className="flex flex-col h-full justify-between menuSec">
          <div className="upperMenu">
             
              {isOpen ? (
                <>
                <div className="flex flex-col mb-5">
                  <Sidebar.Logo
                    img={images.IrisLogo}
                    imgAlt="Flowbite logo"
                    className="logoSec"
                  >
                  </Sidebar.Logo>
                
                  <Button onClick={onToggleSidebar} className="menuBtn mt-1">
                    <HiChevronDoubleRight className="p-0 text-2xl text-neutral-600 hover:text-neutral-400" />
                  </Button>
                </div>
                </>
              ):(
                <>
                <div className="flex items-center mb-5">
                  <Sidebar.Logo
                    img={images.IrisLogo}
                    imgAlt="Flowbite logo"
                    className="logoSec"
                  >
                    Ultra Iris
                  </Sidebar.Logo>
                
                  <Button onClick={onToggleSidebar} className="menuBtn mt-1 pl-4">
                    <HiChevronDoubleLeft className="p-0 text-xl text-neutral-600 hover:text-neutral-400" />
                  </Button>
                </div>
                </>
              )}

            <div>
              <Sidebar.Items>
                <Sidebar.ItemGroup>
                  <Sidebar.Collapse icon={HiChartPie} label="Account Audit">
                    {!isOpen && (
                      <>
                      <Sidebar.Item
                        as="div"
                        active={isActive("/audit-report")}
                        className="pd00 sidebar-dropdown-item"
                      >
                        <Link className="sidebar-a" to="/audit-report">
                          Meta Ads
                        </Link>
                      </Sidebar.Item>
                      <Sidebar.Item
                        as="div"
                        active={isActive("/google-audit")}
                        className="pd00 sidebar-dropdown-item"
                      >
                        <Link className="sidebar-a" to="/google-audit">
                          Google Ads
                        </Link>
                      </Sidebar.Item>
                      </>
                    )}
                  </Sidebar.Collapse>

                 
                    
                  

                  <Sidebar.Item
                    as="div"
                    icon={HiClipboardList}
                    active={isActive("/media-planning")}
                    className="pd00"
                  >
                    <Link className="sidebar-a" to="/media-planning">
                      Planning
                    </Link>
                  </Sidebar.Item>

                  <Sidebar.Collapse
                    icon={() => (
                      <img
                        src={images.optimisation}
                        className="sidebar-icon-img"
                        alt="icon"
                      />
                    )}
                    className="remove-space"
                    label="Optimization AI"
                  >
                    <Sidebar.Item
                      icon={() => <span></span>}
                      as="div"
                      active={isActive("/optimization-status")}
                      className="pd00 sidebar-dropdown-item"
                    >
                      <Link className="sidebar-a" to="/optimization-status">
                        Status
                      </Link>
                    </Sidebar.Item>
                    <Sidebar.Item
                      icon={() => <span></span>}
                      as="div"
                      active={isActive("/optimization-take-off")}
                      className="pd00 sidebar-dropdown-item"
                    >
                      <Link className="sidebar-a" to="/optimization-take-off">
                        Take Off
                      </Link>
                    </Sidebar.Item>
                    <Sidebar.Item
                      icon={() => <span></span>}
                      as="div"
                      active={isActive("/optimization-co-pilot")}
                      className="pd00 sidebar-dropdown-item"
                    >
                      <Link className="sidebar-a" to="/optimization-co-pilot">
                        Co-Pilot
                      </Link>
                    </Sidebar.Item>
                  </Sidebar.Collapse>

                  <Sidebar.Item
                    as="div"
                    icon={() => (
                      <img
                        src={images.idea}
                        className="sidebar-icon-img"
                        alt="icon"
                      />
                    )}
                    active={isActive("/creative-ai")}
                    className="pd00"
                  >
                    <Link className="sidebar-a" to="/creative-ai">
                      Creative AI
                    </Link>
                  </Sidebar.Item>

                  <Sidebar.Item
                    as="div"
                    icon={HiUser}
                    active={isActive("/audience")}
                    className="pd00"
                  >
                    <Link className="sidebar-a" to="/audience">
                      Audience AI
                    </Link>
                  </Sidebar.Item>

                  <Sidebar.Item
                    as="div"
                    icon={HiPresentationChartLine}
                    active={isActive("/campaign-analytics")}
                    className="pd00"
                  >
                    <Link className="sidebar-a" to="/campaign-analytics">
                      Campaign Analytics
                    </Link>
                  </Sidebar.Item>
                </Sidebar.ItemGroup>
              </Sidebar.Items>
            </div>
          </div>

          <div className="bottomMenu">
            <div className="">
              <Sidebar.Items>
                <Sidebar.ItemGroup>
                  {accountInfo?.email === "admin.social@affle.com" && (
                    <Sidebar.Item as="div" icon={HiCog} className="pd00">
                      <Link className="sidebar-a" to="/configure">
                        Settings
                      </Link>
                    </Sidebar.Item>
                  )}
                  <Sidebar.Item
                    icon={HiDocumentText}
                    onClick={() => navigate("/support")}
                  >
                    Support
                  </Sidebar.Item> 
                  <Sidebar.Item
                    icon={HiLogout}
                    onClick={() => setOpenModal(true)}
                    className="sidebar-item"
                  >
                    Logout
                  </Sidebar.Item>
                </Sidebar.ItemGroup>
              </Sidebar.Items>

              <div className="pt-4 mt-4 border-t border-neutral-200 flex gap-3 items-center logOutSec">
                <div className="flex items-center justify-center w-8 h-8 bg-blue-700 text-white text-base font-bold rounded-full">
                  <span>{loginData?.name?.substring(0, 2).toUpperCase()}</span>
                </div>
                <div className="avtarContent">
                  <div className="mb-0.5 text-base font-semibold leading-none text-gray-900 dark:text-white peer-has-[collapseSide]:hidden">
                    {loginData?.name}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {loginData?.email}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sidebar> */}
    </>
  );
};
